import getInLinksPage from "@/pageComponents/inlink";

const Page = getInLinksPage("pin");

export default Page.PageComponent;
export const getServerSideProps = Page.getServerSideProps;
